import { lifeActionTypes } from 'src/actions/actionTypes'

const updateLifeUserDetails = (userDetails) => {
  return {
    type: lifeActionTypes.UPDATE_LIFE_USER_DETAILS,
    payload: userDetails,
  }
}

const updateLifeUserAgeDetails = (ageDetails) => {
  return {
    type: lifeActionTypes.UPDATE_LIFE_MEMBER_AGE_DETAILS,
    payload: ageDetails,
  }
}

const updateLifeSelectedQuickQuote = (quickQuote) => {
  return {
    type: lifeActionTypes.UPDATE_LIFE_SELECTED_QUICK_QUOTE,
    payload: quickQuote,
  }
}

const updateLifeProposerDetails = (proposerDetails) => {
  return {
    type: lifeActionTypes.UPDATE_LIFE_PROPOSER_DETAILS,
    payload: proposerDetails,
  }
}

const updateLifeInsuredMemberDetails = (insuredMemberDetails) => {
  return {
    type: lifeActionTypes.UPDATE_LIFE_INSURED_MEMBER_DETAILS,
    payload: insuredMemberDetails,
  }
}

const updateLifeNomineeDetails = (nomineeDetails) => {
  return {
    type: lifeActionTypes.UPDATE_LIFE_INSURED_MEMBER_DETAILS,
    payload: nomineeDetails,
  }
}

export {
  updateLifeUserDetails,
  updateLifeUserAgeDetails,
  updateLifeSelectedQuickQuote,
  updateLifeInsuredMemberDetails,
  updateLifeProposerDetails,
  updateLifeNomineeDetails,
}
